(() => {
  if (window.noomLazyVideoInitialized) return;
  window.noomLazyVideoInitialized = true;

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = new Set();
  const inView = new Set();
  const nativeControls = new WeakMap();
  const visible = (video) => video.getClientRects().length > 0;

  function load(video) {
    if (!visible(video) || video.dataset.noomLoaded) return;
    video.dataset.noomLoaded = 'true';
    if (video.dataset.poster) video.poster = video.dataset.poster;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.preload = motion.matches ? 'metadata' : 'auto';
    video.load();
  }

  function play(video) {
    if (motion.matches || document.hidden || !video.hasAttribute('data-noom-autoplay') || !visible(video)) return;
    load(video);
    video.muted = true;
    video.play().catch(() => {
      if (inView.has(video)) video.controls = true;
    });
  }

  function controls(video) {
    video.controls = motion.matches || nativeControls.get(video);
    if (video.controls) video.removeAttribute('aria-hidden');
  }

  const nearby = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({target, isIntersecting}) => {
      if (isIntersecting) load(target);
    });
  }, {rootMargin: '250px 0px'}) : null;

  const viewport = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({target, isIntersecting}) => {
      if (isIntersecting) {
        inView.add(target);
        play(target);
      } else {
        inView.delete(target);
        target.pause();
      }
    });
  }) : null;

  function init(root = document) {
    root.querySelectorAll('video[data-noom-lazy-video]').forEach((video) => {
      if (videos.has(video)) return;
      videos.add(video);
      nativeControls.set(video, video.controls);
      controls(video);
      if (nearby) {
        nearby.observe(video);
        viewport.observe(video);
      } else {
        load(video);
        play(video);
      }
    });
  }

  motion.addEventListener('change', () => {
    videos.forEach((video) => {
      controls(video);
      if (motion.matches) video.pause();
      else if (inView.has(video)) play(video);
    });
  });
  document.addEventListener('visibilitychange', () => {
    videos.forEach((video) => {
      if (document.hidden) video.pause();
      else if (inView.has(video)) play(video);
    });
  });
  window.addEventListener('pageshow', () => inView.forEach(play));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  init();
})();
